/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/**
 * Register Components
 */
import Vue from 'vue'
import BestSellerProducts from './components/blocks/BestSellerProducts';
import SearchProducts from './components/search/SearchProducts';
import AddToCartWrapper from './components/product/detail/AddToCartWrapper';
import SelectProductOptionInput from './components/inputs/SelectProductOptionInput';
import AddToCart from './components/buttons/AddToCart';
import RemoveFromCart from './components/buttons/RemoveFromCart';
import QuantityInput from './components/inputs/QuantityInput';
import Price from './components/product/detail/Price';
import PriceWithoutTax from './components/product/detail/PriceWithoutTax';
import ProductAddedPopup from './components/popups/ProductAddedPopup';
import BasketQuantity from './components/cart/BasketQuantity';
import ProductListing from './components/product/ProductListing';
import Carousel from './components/slider/Carousel';
import Services from './components/blocks/Services';
import TopCategories from './components/blocks/TopCategories';
import ScrollButton from './components/buttons/ScrollButton';
import SearchIcon from './components/buttons/SearchIcon';
import Tabs from './components/product/detail/Tabs';
import ProductPreviewImage from './components/product/detail/ProductPreviewImage';
import Stock from './components/product/detail/Stock';
import Manufacturer from './components/product/detail/Manufacturer';
import Loader from './components/globals/Loader';
import CityInput from './components/inputs/CityInput';
import SelectizeInput from './components/inputs/SelectizeInput';
import CookieLaw from 'vue-cookie-law';

/**
 * Register Plugins
 */
import VueModalTor from "vue-modaltor/dist/vue-modaltor.common";
import VueScrollTo from 'vue-scrollto';

/**
 * Vue use
 */
Vue.use(VueModalTor);
Vue.use(VueScrollTo);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',

    components: {
        BestSellerProducts,
        SearchProducts,
        SearchIcon,
        AddToCartWrapper,
        AddToCart,
        SelectProductOptionInput,
        QuantityInput,
        ProductAddedPopup,
        Price,
        PriceWithoutTax,
        BasketQuantity,
        RemoveFromCart,
        ProductListing,
        Carousel,
        Services,
        TopCategories,
        ScrollButton,
        Tabs,
        ProductPreviewImage,
        Stock,
        Manufacturer,
        Loader,
        SelectizeInput,
        CityInput,
        CookieLaw
    }
});
